import { DragEvent } from 'react';
import { IProject } from '../../../planner-interfaces';

interface IProjectMenuDragButtonProps {
    project: IProject;
}

const DRAG_CLASS = 'project-menu-dragging';

const ProjectMenuDragButton = (props: IProjectMenuDragButtonProps) => {

    const { project } = props;

    const style = {
        backgroundColor: project.project_color,
    };

    /**
     * https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/setData
     */
    const sourceOnDragStart = (evt: DragEvent<HTMLDivElement>) => {
        evt.stopPropagation();

        // Clear the actions data cache (for all formats/types)
        evt.dataTransfer.clearData();

        evt.dataTransfer.setData('text/plain', project.project_id.toString());

        // https://stackoverflow.com/questions/19639969/html5-dragend-event-firing-immediately
        ((_currentTarget) => {
            window.setTimeout(() => {
                document.body.classList.add(DRAG_CLASS);
            }, 0)
        })(evt.currentTarget);
    };

    const sourceOnDragEnd = (evt: DragEvent<HTMLDivElement>) => {
        evt.stopPropagation();
        document.body.classList.remove(DRAG_CLASS);
    };

    const sourceOnDrag = (evt: DragEvent<HTMLDivElement>) => {
        evt.stopPropagation();
    };

    const sourceOnDrop = (evt: DragEvent<HTMLDivElement>) => {
        evt.stopPropagation();
    };

    return (
        <div
            draggable={ true }
            onDragStart={ sourceOnDragStart }
            onDragEnd={ sourceOnDragEnd }
            onDrag={ sourceOnDrag }
            onDrop={ sourceOnDrop }
            className="project-menu__drag-btn cursor-move w-[10px] h-[10px] rounded-full mr-4"
            style={ style }
        />
    )
};

export default ProjectMenuDragButton;